/* global axios */
import ApiClient from './ApiClient';

class ChangelogEntriesAPI extends ApiClient {
  constructor() {
    super('changelog_entries', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  getUnreadCount() {
    return axios.get(`${this.url}/unread_count`);
  }
}

export default new ChangelogEntriesAPI();
